import React from 'react';

function PrivacyPolicy({ onBack }) {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-between">
      <div>
        <header className="bg-white border-b border-gray-100">
          <nav className="container mx-auto px-6 py-4 flex justify-between items-center">
            <img src="/x-logo.svg" alt="xharely" className="h-10 w-10 cursor-pointer" onClick={onBack} />
            <button 
              onClick={onBack}
              className="text-gray-700 hover:text-black transition font-medium"
            >
              ← Kembali ke Beranda
            </button>
          </nav>
        </header>

        <main className="container mx-auto px-6 py-16 max-w-4xl">
          <div className="bg-white rounded-3xl p-8 sm:p-12 shadow-sm border border-gray-100 space-y-8">
            <div>
              <h1 className="text-3xl sm:text-4xl font-bold text-black mb-2">Kebijakan Privasi</h1>
              <p className="text-gray-500 text-sm">Terakhir diperbarui: 16 Agustus 2026</p>
            </div>

            <section className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Selamat datang di <strong>xharely</strong> (dioperasikan oleh <strong>PT Xharely Teknologi Indonesia</strong>). Kami sangat menghargai dan berkomitmen untuk melindungi privasi serta keamanan data pribadi pengguna kami.
              </p>
              <p>
                Kebijakan Privasi ini menjelaskan bagaimana kami mengumpulkan, menggunakan, menyimpan, dan melindungi informasi Anda saat menggunakan situs web <code>xharely.com</code>, aplikasi <code>pos.xharely.com</code>, dan seluruh layanan terkait.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-bold text-black">1. Informasi yang Kami Kumpulkan</h2>
              <p className="text-gray-700 leading-relaxed">
                Kami dapat mengumpulkan informasi yang Anda berikan secara langsung saat mendaftar, berlangganan, atau menghubungi kami, meliputi:
              </p>
              <ul className="list-disc list-inside space-y-1.5 text-gray-600 pl-2">
                <li><strong>Informasi Akun:</strong> Nama lengkap, alamat email, nomor telepon/WhatsApp, nama bisnis/merchant.</li>
                <li><strong>Data Transaksi Bisnis (Khusus Pengguna xharelyPOS):</strong> Data produk/katalog, riwayat pesanan, struk transaksi, dan laporan penjualan.</li>
                <li><strong>Data Teknis:</strong> Alamat IP, jenis browser, perangkat, dan data penggunaan aplikasi untuk peningkatan stabilitas layanan.</li>
              </ul>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-bold text-black">2. Penggunaan Informasi</h2>
              <p className="text-gray-700 leading-relaxed">
                Informasi yang kami kumpulkan digunakan untuk:
              </p>
              <ul className="list-disc list-inside space-y-1.5 text-gray-600 pl-2">
                <li>Menyediakan, memelihara, dan mengoptimalkan fungsi layanan xharely & xharelyPOS.</li>
                <li>Memproses pembayaran langganan secara aman melalui mitra payment gateway resmi.</li>
                <li>Mengirimkan notifikasi akun, verifikasi email, struk digital, dan informasi pembaruan sistem.</li>
                <li>Memberikan layanan bantuan pelanggan (customer support).</li>
              </ul>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-bold text-black">3. Keamanan Data</h2>
              <p className="text-gray-700 leading-relaxed">
                Kami menerapkan standar keamanan teknis dan organisasional tingkat industri, termasuk enkripsi SSL/TLS 256-bit dan proteksi firewall untuk melindungi data Anda dari akses tanpa izin, perubahan, atau kebocoran data.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-bold text-black">4. Pembagian Informasi kepada Pihak Ketiga</h2>
              <p className="text-gray-700 leading-relaxed">
                Kami <strong>tidak pernah menjual atau menyewakan</strong> data pribadi Anda kepada pihak mana pun. Data hanya dibagikan kepada mitra penyedia infrastruktur pembayaran dan email resmi (seperti Xendit dan SendGrid) semata-mata untuk memproses transaksi yang Anda lakukan.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-bold text-black">5. Hak Pengguna</h2>
              <p className="text-gray-700 leading-relaxed">
                Anda memiliki hak untuk mengakses, memperbarui, atau meminta penghapusan data akun Anda kapan saja dengan menghubungi tim dukungan kami.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-bold text-black">6. Hubungi Kami</h2>
              <p className="text-gray-700 leading-relaxed">
                Jika Anda memiliki pertanyaan tentang Kebijakan Privasi ini, silakan hubungi kami:
              </p>
              <div className="bg-gray-50 rounded-2xl p-6 text-sm text-gray-700 space-y-1.5 border border-gray-100">
                <p><strong>PT Xharely Teknologi Indonesia</strong></p>
                <p>Alamat: Jl. Kayangan, Tangkerang Barat, Marpoyan Damai, Pekanbaru, Riau, Indonesia (28282)</p>
                <p>Email: <a href="mailto:contact@xharely.com" className="text-black underline font-medium">contact@xharely.com</a></p>
                <p>WhatsApp: <a href="https://wa.me/6285121210306" target="_blank" rel="noopener noreferrer" className="text-green-600 underline font-medium">+62 851-2121-0306</a></p>
              </div>
            </section>
          </div>
        </main>
      </div>

      {/* Footer */}
      <footer className="bg-white pt-16 pb-12 border-t border-gray-100 mt-12">
        <div className="container mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500">
            <p>&copy; {new Date().getFullYear()} PT Xharely Teknologi Indonesia. All rights reserved.</p>
            <img src="/x-logo-text.svg" alt="xharely" className="h-8 w-auto" />
          </div>
        </div>
      </footer>
    </div>
  );
}

export default PrivacyPolicy;
